/**
 * 2026-11-03 UAT A26-1（和田様）。グラフの色は、見本の青の濃淡4色にそろえる（クライアント分析・ドライバー詳細）。
 * 以前は水色・ベージュ・赤茶など15色で、画面の色合い（トンマナ）と合っていなかった。
 * 濃い順に並べ、タスクが4つより多いときは、この順をくり返す。
 */
export const CHART_BLUES = ['#293E6B', '#5B78A6', '#A7B9D4', '#E5EAF2'] as const;

/**
 * 棒の枠の色。いちばん薄い #E5EAF2 は白い背景とほとんど同じなので、どの棒にも濃い青の枠を付けて、
 * 背景と、積み上げた隣の棒との境を見えるようにする。
 */
export const CHART_BAR_BORDER = CHART_BLUES[0];

/** 1系列だけのグラフ（ドライバー詳細の勤務実績）の棒の色。 */
export const CHART_SINGLE = CHART_BLUES[1];
